/*****************************************************************
 * Viewport HANDLER
 * ***************************************************************/

let viewportMode, viewports

const viewers = {
    single: [{name:'main'}],
    triple: [{name:'bottom'}, {name:'front'}, {name:'top'}],
    double: [{name:'bottom'}, {name:'top'}],
    comparative: [{name:'comparative'}, {name:'main'}],
  }

export const setviewportMode = mode => {
      viewportMode = ( mode !== undefined) ? mode : 'single'
      viewports = viewers[viewportMode]
  },
    getViewports = () => viewports,
    getViewportMode = () => viewportMode;
